// jsdom's window.location is non-configurable, so it can't be reassigned or
// spied on directly in tests. Routing calls through this wrapper gives tests
// a boundary to mock instead.
export const reloadPage = () => window.location.reload();
